import type { FC, HTMLProps } from 'react';

import type { PriceFragment } from '@boc/framework/saleor-graphql';

export const Price: FC<
  Omit<HTMLProps<HTMLDivElement>, 'children'> & {
    price?: PriceFragment;
    label?: string;
    zeroAsFree?: boolean;
    truncate?: boolean;
  }
> = ({ price, label, zeroAsFree = false, truncate = false, ...props }) => {
  if (!price) {
    return null;
  }

  if (zeroAsFree && price.amount === 0) {
    return (
      <span aria-label={label} {...props}>
        Free
      </span>
    );
  }

  const formatted = price.amount.toLocaleString('en', {
    style: 'currency',
    currency: price.currency,
    maximumFractionDigits: truncate ? 0 : 2,
  });

  return (
    <span aria-label={label} {...props}>
      {formatted}
    </span>
  );
};
